import { forwardRef, useState } from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { FaTimes } from 'react-icons/fa';
import s from './RequestCard.module.scss';
import ErrorModal from '../../../../../common/ErrorModal';
import modalIcon from '../../../../../../images/lab-test/emergency-tick.svg';
import { ReactComponent as AngleRight } from '../../../Icons/AngleRight.svg';
// ... rest of imports
import { initiateCallByUser } from '../../../services';
import { payLabCopay } from '../../../../../../services';
import { ReactComponent as LocationIcon } from '../../../Icons/Location-Outlined.svg';
import { ReactComponent as PatientIcon } from '../../../Icons/Patient.svg';
import { ReactComponent as CentreVisitIcon } from '../../../Icons/CenterVisitIcon.svg';
import { ReactComponent as OpenDoorIcon } from '../../../Icons/Open-Door.svg';
import { ReactComponent as HashtagIcon } from '../../../Icons/hashtag.svg';
import { ReactComponent as LabIcon } from '../../../Icons/lab.svg';
import { ReactComponent as DoctorIcon } from '../../../Icons/doctor.svg';
import { ReactComponent as HomeVisitIcon } from '../../../Icons/HomeVisitIcon.svg';
import { ReactComponent as ClockFillIcon } from '../../../Icons/clock-fill.svg';
import SearchLogo from '../../../Images/GIF/Finding.gif';
import CartLogo from '../../../Icons/card-logo.svg';
import OrderLogo from '../../../Icons/Hospital.svg';
import OrderRedLogo from '../../../Icons/order-red-logo.svg';
import PrescriptionIcon from '../../../Icons/order-logo.svg';
import samplePickupIcon from '../../../Icons/precription-card-icon.svg';
import { logEvent } from '../../../../../../utils/logEvent';

const ORDER_CONFIRMED_TYPES = [
  // 'partnerConfirmation',
  'orderUpdatePartner',
  'partialReportGenerated',
  'reportGenerated',
  'partnerConfirmed',
  'orderUpdate',
  'delivery',
  'samplePickUp',
];

const CARD_STYLE_CONFIG = {
  digitisationDelayed: {
    barClass: s.barQuery,
    label: 'Action Required',
  },
  copay: {
    barClass: s.barQuery,
    label: 'Payment Pending',
  },
  sampleProcessing: {
    barClass: s.barProcess,
    label: 'Sample Processing',
  },
  samplePickUp: {
    barClass: s.barSuccess,
    label: 'Sample Pickup',
  },
  orderPlaced: {
    barClass: s.barProcess,
    label: 'Order Placed',
  },

  // Success (Green)
  // Success (Green)
  partnerConfirmation: {
    barClass: s.barSuccess,
    // label: 'Confirmation awaited',
  },
  cashlessLetterGenerated: {
    barClass: s.barProcess,
    label: 'Letter Ready',
  },
  availableCart: {
    barClass: s.barProcess,
    label: 'Ready to book',
  },
  // New Mappings
  digitisationRejected: { barClass: s.barQuery, label: 'Action Required' },
  digitisationPending: {
    barClass: s.barProcess,
    label: 'Digitisation in process',
  },
  LookingForPartner: { barClass: s.barQuery, label: 'Searching' },
  fetchingPartner: { barClass: s.barQuery, label: 'Searching' },
  partnerNotFound: { barClass: s.barProcess, label: 'Partner Not Found' },
  partnerFound: { barClass: s.barProcess, label: 'Partner Found' },
  partnerConfirmed: { barClass: s.barSuccess, label: 'Confirmed' },
  orderUpdate: { barClass: s.barSuccess, label: 'Order Update' },
  orderUpdatePartner: { barClass: s.barSuccess, label: 'Order Update' },
  orderCancelled: { barClass: s.barQuery, label: 'Cancelled' }, // Assuming Red for Cancelled
  delivery: { barClass: s.barSuccess, label: 'Out for Delivery' },
  partialReportGenerated: { barClass: s.barSuccess, label: 'Report Generated' },
  reportGenerated: { barClass: s.barSuccess, label: 'Report Generated' },
  orderUpdateReschedule: { barClass: s.barProcess, label: 'Rescheduled' },
  prescription_verfication_under_process: {
    barClass: s.barProcess,
    label: 'Prescription Under Verification',
    spinner: true,
  },
  prescription_verified: {
    barClass: s.barQuery,
    label: 'Action Required',
  },
  cashlessApprovalPending: {
    barClass: s.barProcess,
    label: 'Cashless Approval Pending',
    spinner: true,
  },
  cashlessApprovalCompleted: {
    barClass: s.barQuery,
    label: 'Action required',
  },
};

const truncateText = (text, maxLength = 45) => {
  if (!text) return text;
  return text.length > maxLength ? `${text.slice(0, maxLength).trim()}…` : text;
};

const getCountLabel = (card) => {
  const packageCount = Number(card?.packageCount) || 0;
  if (packageCount > 0) {
    return `(${packageCount} ${packageCount > 1 ? 'Packages' : 'Package'})`;
  }

  const testCount = Number(card?.testCount) || 0;
  if (testCount > 0) {
    return `(${testCount} ${testCount > 1 ? 'Tests' : 'Test'})`;
  }

  return null;
};

const renderInfoSection = (card) => {
  console.log('renderInfoSection card:', card);
  switch (card.cardType) {
    case 'digitisationDelayed':
    case 'digitisationRejected':
    case 'cashlessApprovalRejected':
      return (
        <>
          <div className={s.infoHeader}>
            <span className={s.infoTitle}>{card.title}</span>
            <AngleRight />
          </div>
          <div className={s.infoStack}>
            <p className={s.reasonText}>
              {/* <strong>Reason: </strong>{' '} */}
              {truncateText(card.infoText || card.reason)}
            </p>
          </div>
        </>
      );

    case 'digitisationPending':
      return (
        <>
          <div className={s.infoHeader}>
            <span className={s.infoTitle}>{card.title}</span>
            <AngleRight />
          </div>
          <div className={s.infoStack}>
            {card.digitisationId && (
              <p className={s.infoText}>
                <HashtagIcon />
                Digitisation ID: {card.digitisationId}
              </p>
            )}
            <p className={s.infoText}>{card.infoText}</p>
          </div>
        </>
      );
    case 'cashlessApprovalPending':
      return (
        <>
          <div className={s.infoHeader}>
            <span className={s.infoTitle}>{card.title}</span>
            <AngleRight />
          </div>
          <div className={s.infoStack}>
            {card.digitisationId && (
              <p className={s.infoText}>
                <HashtagIcon />
                Digitisation ID: {card.digitisationId}
              </p>
            )}
            <p className={s.infoText}>{card.infoText}</p>
          </div>
        </>
      );
    case 'cashlessApprovalCompleted':
      return (
        <>
          <div className={s.infoHeader}>
            <span className={s.infoTitle}>{card.title}</span>
            <AngleRight />
          </div>
          <div className={s.infoStack}>
            {(card.orderId || card.digitisationId) && (
              <p className={s.infoText}>
                <HashtagIcon />
                {card.orderId ? 'Order ID:' : 'Digitisation ID:'}{' '}
                {card.orderId ?? card.digitisationId}
              </p>
            )}
            <p className={s.infoText}>{card.infoText}</p>
          </div>
        </>
      );

    case 'LookingForPartner':
    case 'fetchingPartner':
      return (
        <>
          <div className={s.infoHeader}>
            <span className={s.infoTitle}>{card.title}</span>
            <AngleRight />
          </div>
          <div className={`${s.infoStack} ${s.compactGap}`}>
            {/* Patient */}
            <p className={s.patientRow}>
              <PatientIcon />
              <span className={s.rowText}>{card.patientName}</span>
            </p>
            {/* Lab Name (hardcoded as Pathology per req) */}
            <p className={s.locationRow}>
              <LabIcon />
              <span className={s.rowText}>{card.testsTypeName}</span>
            </p>
            {/* Request ID */}
            <p className={s.infoText}>
              <HashtagIcon />
              Request ID: {card.requestId || card.digitisationId}
            </p>
          </div>
        </>
      );

    case 'availableCart':
    case 'partnerNotFound':
    case 'partnerFound':
      return (
        <>
          <div className={s.infoHeader}>
            <span className={s.infoTitle}>{card.title}</span>
            <AngleRight />
          </div>

          <div className={`${s.infoStack} ${s.compactGap}`}>
            {/* Request ID */}
            {(card.requestId || card.digitisationId) && (
              <p className={s.infoText}>
                <HashtagIcon />
                {card.requestId ? 'Request ID:' : 'Digitisation ID:'}{' '}
                {card.requestId ?? card.digitisationId}
              </p>
            )}
            {/* Doctor / Consultation - optional */}
            {card.doctorName && card.title !== 'Place Order' && (
              <p className={s.infoText}>
                <DoctorIcon />
                {card.doctorName}
              </p>
            )}
            {/* Patient */}
            {card.patientName && (
              <p className={s.patientRow}>
                <PatientIcon />
                <span className={s.rowText}>{card.patientName}</span>
              </p>
            )}

            {/* Test Type */}
            <p
              className={s.infoText}
              onClick={(e) => {
                e.stopPropagation();

                card?.onTestClick(card);
              }}
            >
              <LabIcon />
              {card.testsTypeName || 'Pathology'}{' '}
              {getCountLabel(card) && (
                <span className={s.tests}>{getCountLabel(card)}</span>
              )}
            </p>
          </div>
        </>
      );

    case 'partnerConfirmation':
    case 'orderUpdatePartner':
    case 'orderPlaced':
    case 'samplePickUp':
    case 'sampleProcessing':
    case 'partialReportGenerated':
    case 'copay':
    case 'reportGenerated':
    case 'partnerConfirmed':
    case 'orderUpdate':
    case 'orderCancelled':
    case 'delivery':
      return (
        <>
          <div className={s.infoHeader}>
            <span className={s.infoTitle}>{card.title}</span>
            <AngleRight />
          </div>
          <div className={`${s.infoStack} ${s.compactGap}`}>
            {/* Location */}
            {(card.partnerName || card.labName) && (
              <p className={s.locationRow}>
                <LocationIcon />
                <span className={s.rowText}>
                  {card.partnerName || card.labName}
                </span>
              </p>
            )}

            {/* Order ID for cancelled orders, Request ID otherwise */}
            {card.cardType === 'orderCancelled' && card.orderId ? (
              <p className={s.infoText}>
                <HashtagIcon />
                Order ID: {card.orderId}
              </p>
            ) : (
              (card?.requestId || card.digitisationId) && (
                <p className={s.infoText}>
                  <HashtagIcon />
                  Request ID: {card.requestId || card.digitisationId}
                </p>
              )
            )}

            {/* Patient */}
            {card.patientName && (
              <p className={s.patientRow}>
                <PatientIcon />
                <span className={s.rowText}>{card.patientName}</span>
              </p>
            )}

            {/* Visit Type + Test Count */}
            <p className={s.visitTypeRow}>
              {card.partnerCenterId ? <CentreVisitIcon /> : <LabIcon />}
              <span className={s.rowText}>
                {/* Logic: if Labname is Pathology then Center Visit text otherwise Home visit */}
                {card.partnerCenterId ? 'Centre Visit' : 'Home Visit'}{' '}
                {getCountLabel(card) && (
                  <strong
                    onClick={(e) => {
                      e.stopPropagation();
                      card?.onTestClick(card);
                    }}
                  >
                    {getCountLabel(card)}
                  </strong>
                )}
              </span>
            </p>
          </div>
        </>
      );

    case 'cashlessLetterGenerated':
    case 'orderUpdateReschedule':
      return (
        <>
          <div className={s.infoHeader}>
            <span className={s.infoTitle}>{card.title}</span>
            <AngleRight />
          </div>
          <div className={`${s.infoStack} ${s.compactGap}`}>
            {/* Location */}
            <p className={s.locationRow}>
              <LocationIcon />
              <span className={s.rowText}>{card.partnerName}</span>
            </p>

            {/* Patient */}
            <p className={s.patientRow}>
              <PatientIcon />
              <span className={s.rowText}>{card.patientName}</span>
            </p>

            {/* Visit Type */}
            <p className={s.visitTypeRow}>
              {card?.partnerCenterId ? <CentreVisitIcon /> : <LabIcon />}
              <span className={s.rowText}>
                {card.partnerCenterId ? 'Centre Visit' : 'Home Visit'}{' '}
                {getCountLabel(card) && <strong>{getCountLabel(card)}</strong>}
              </span>
            </p>
          </div>
        </>
      );
    case 'prescription_verfication_under_process':
      return (
        <>
          <div className={s.infoHeader}>
            <span className={s.infoTitle}>{card.title}</span>
          </div>
          <div className={s.infoStack}>
            <p className={s.infoText}>{card.infoText}</p>
          </div>
        </>
      );

    case 'prescription_verified': {
      const payMatch = card.infoText?.match(/^(.*?)(pay ₹\d+.*)$/i);
      return (
        <>
          <div className={s.infoHeader}>
            <span className={s.infoTitle}>{card.title}</span>
          </div>
          <div className={s.infoStack}>
            <p className={s.infoText}>
              <span>
                {payMatch ? (
                  <>
                    {payMatch[1]}
                    <strong className={s.payHighlight}>{payMatch[2]}</strong>
                  </>
                ) : (
                  card.infoText
                )}
              </span>
            </p>
          </div>
        </>
      );
    }

    default:
      return (
        <div className={s.infoStack}>
          <p className={s.infoText}>{card.infoText}</p>
        </div>
      );
  }
};

const getFallbackLogo = (cardType) => {
  if (cardType === 'LookingForPartner' || cardType === 'fetchingPartner') {
    return SearchLogo;
  }
  if (
    cardType === 'availableCart' ||
    cardType === 'partnerFound' ||
    cardType === 'partnerNotFound'
  ) {
    return CartLogo;
  }
  if (
    cardType === 'prescription_verfication_under_process' ||
    cardType === 'prescription_verified' ||
    cardType === 'cashlessApprovalCompleted'
  ) {
    return PrescriptionIcon;
  }
  if (cardType === 'samplePickUp') {
    return samplePickupIcon;
  }
  if (
    cardType === 'cashlessApprovalRejected' ||
    cardType === 'digitisationRejected'
  ) {
    return OrderRedLogo;
  }
  return OrderLogo;
};

const RequestCard = forwardRef((props, ref) => {
  console.log('RequestCard props:', props); // Debugging line to check props
  const history = useHistory();
  const authToken = useSelector((state) => state.user.authToken);
  const [isPaying, setIsPaying] = useState(false);
  const [modalDetails, setModalDetails] = useState({
    showModal: false,
    modalText: '',
  });
  const {
    cardType,
    title,
    status,
    infoText,
    digitisationId,
    uploadedOn,
    collectionDate,
    slot,
    index,
    orderId,
    cartId,
    isConciergeBooking,
    partnerLogoUrl,
    testsType,
    isScanNpay,
    isScanAndPayFlow = false,
    scanAndPayQrId,
    scanAndPayPartnerId,
    scanAndPayCenterId,
    requestId,
    addressId,
    patientName,
    consultADoctor,
    isLabConsultSponsor,
  } = props;

  console.log('title', title, 'cardType', cardType, 'infoText', infoText);

  const loginState = useSelector((state) => state.app?.loginState);

  const statusUI =
    CARD_STYLE_CONFIG[cardType] || CARD_STYLE_CONFIG['digitisationDelayed'];

  // Post-facto analytics props. The home card payload exposes an explicit
  // `isPostFactoOrder` flag and the copay amount; the covered/uncovered test
  // split is not present in this payload, so only the available fields are sent.
  const postFactoEventProps = {
    orderID: orderId,
    pendingCopayAmount: props.pendingCopayAmount,
    queryReason: props.reason || infoText,
    isSearchBookPostFacto: props.isPostFactoOrder ? 'Yes' : 'No',
  };

  const handleCardClick = () => {
    const eventName = isScanAndPayFlow
      ? 'Scan QR Your Request’s card clicked'
      : 'Your Request’s card clicked';
    logEvent(eventName, {
      cardStatus: cardType,
      orderId,
      digitisationId,
      cartId,
      cartType: testsType,
      sequenceOfCard: index + 1,
      ...(isScanAndPayFlow && {
        qrId: scanAndPayQrId,
        partnerId: scanAndPayPartnerId,
        centerId: scanAndPayCenterId,
        isLoggedIn: loginState === 'LOGGED_IN',
        entrySource: 'scan_and_pay',
      }),
      ...(props.isPostFactoOrder && postFactoEventProps),
    });

    if (props.onCardClick) {
      props.onCardClick({
        cardType,
        digitisationId,
        orderId,
        cartId,
        uploadedOn,
        collectionDate,
        slot,
      });
      return;
    }
    if (
      isScanAndPayFlow &&
      [
        'availableCart',
        'digitisationPending',
        'cashlessLetterGenerated',
      ].includes(cardType)
    ) {
      history.push('/lab-test/order', { digitisationId, cartId });
    } else {
      if (cardType === 'availableCart') {
        history.push('/lab-test/lab-select', {
          cartId,
        });
      } else if (cardType === 'LookingForPartner') {
        history.push('/lab-test/lab-select', {
          cartId,
          requestId,
          addressId,
        });
      } else {
        history.push('/lab-test/order-status', {
          orderId,
          digitisationId,
          cartId,
        });
      }
    }
  };

  const handleHelpClick = (e) => {
    e.stopPropagation();
    if (orderId) {
      initiateCallByUser(authToken, orderId)
        .then((res) => {
          const message = res?.showMessage || res?.message || '';
          if (message) {
            setModalDetails({ showModal: true, modalText: message });
          }
        })
        .catch((err) => {
          console.error('Call initiation failed:', err);
        });
    }
  };

  const hideModal = (e) => {
    e.stopPropagation();
    setModalDetails({ showModal: false, modalText: '' });
  };

  const handleConsultDoctorClick = (e) => {
    e.stopPropagation();
    history.push('/consultation/doctor-select', {
      labsFlow: isLabConsultSponsor ? 'labsConsultSearchFlow' : '',
      labOrderId: orderId,
      labPatientName: patientName,
      showSearch: !isLabConsultSponsor,
      labsSelectedVertical: !isLabConsultSponsor ? 'labsConsultSearchFlow' : '',
    });
  };

  return (
    <>
      {isPaying && (
        <div className={s.payingOverlay} onClick={(e) => e.stopPropagation()}>
          <div className={s.payingSpinner} />
        </div>
      )}
      <article
        ref={ref}
        data-index={index}
        className={`${s.card} ${statusUI.barClass} ${cardType === 'prescription_verified' ? s.cardAuto : ''}`}
        onClick={handleCardClick}
      >
        {/* TOP BAR */}
        <div className={s.topStrip}>
          {[
            'partnerConfirmation',
            'orderUpdateReschedule',
            'rescheduled',
            'samplePickUp',
            'sampleProcessing',
            'partnerConfirmed',
            'orderPlaced',
          ].includes(cardType) && (
            <>
              {cardType !== 'samplePickUp' && (
                <div className={s.topLeft}>
                  {/* Logic: Centre Visit -> OpenDoor, Home Visit -> HomeVisit (House) */}
                  {props.partnerCenterId ? (
                    <OpenDoorIcon className={s.topLeftIcon} />
                  ) : (
                    <HomeVisitIcon className={s.topLeftIcon} />
                  )}
                </div>
              )}
              <span className={s.topLeftText}>{props.slotDateTime}</span>
            </>
          )}
          {cardType !== 'partnerConfirmation' &&
            cardType !== 'samplePickUp' && (
              <div className={s.statusPill}>
                {statusUI.spinner || statusUI.label === 'Searching' ? (
                  statusUI.spinner ? (
                    <span className={s.pillSpinner} />
                  ) : (
                    <ClockFillIcon className={s.pillIcon} />
                  )
                ) : (
                  <CheckCircleIcon className={s.pillIcon} />
                )}
                <span className={s.pillText}>{statusUI.label}</span>
              </div>
            )}
        </div>

        <div className={s.content}>
          {/* Left icon */}
          <img
            className={s.infoIcon}
            src={partnerLogoUrl || getFallbackLogo(cardType)}
            alt=""
          />

          {/* Right content */}
          <div className={s.info}>{renderInfoSection(props)}</div>
        </div>
        {consultADoctor ? (
          <div className={s.helpFooter} onClick={handleConsultDoctorClick}>
            Consult Doctor
          </div>
        ) : (
          ORDER_CONFIRMED_TYPES.includes(cardType) &&
          props.showEmergencyButtonCall && (
            <div className={s.helpFooter} onClick={handleHelpClick}>
              Need Help?
            </div>
          )
        )}
        {cardType === 'prescription_verified' ||
          (cardType === 'cashlessApprovalCompleted' && (
            <div
              className={s.payNowFooter}
              onClick={(e) => {
                e.stopPropagation();
                if (props.isPostFactoOrder) {
                  logEvent(
                    'Your Request’s Card Pay Now Clicked',
                    postFactoEventProps
                  );
                  // Go straight to the payment gateway (same as OrderStatus),
                  // using this card's auth token (state.user.authToken).
                  // Keep the loader on through navigation; only clear it on error.
                  setIsPaying(true);
                  Promise.resolve(
                    payLabCopay(orderId, history, authToken, true)
                  ).catch((err) => {
                    console.error('Copay payment failed:', err);
                    setIsPaying(false);
                  });
                  return;
                }
                props.onPayNow?.();
              }}
            >
              {props.pendingCopayText || 'Pay Now'}
            </div>
          ))}

        {/* {cardType === 'cashlessApprovalRejected' && (
          <div className={s.viewQueryFooter} onClick={() => props.onPayNow?.()}>
            View Query
          </div>
        )} */}
        {modalDetails.showModal && (
          <ErrorModal>
            <div className={s.helpModalOverlay} onClick={hideModal}>
              <div
                className={s.helpModalBody}
                onClick={(e) => e.stopPropagation()}
              >
                <div className={s.helpModalClose} onClick={(e) => hideModal(e)}>
                  <FaTimes />
                </div>
                <img
                  className={s.helpModalIcon}
                  onClick={(e) => e.stopPropagation()}
                  src={modalIcon}
                  alt=""
                />
                <p
                  className={s.helpModalText}
                  onClick={(e) => e.stopPropagation()}
                >
                  {modalDetails.modalText}
                </p>
              </div>
            </div>
          </ErrorModal>
        )}
      </article>
    </>
  );
});

RequestCard.displayName = 'RequestCard';
export default RequestCard;
